// extracted by mini-css-extract-plugin
export default {"dynamicsLinkContainer":"FirstPage_dynamicsLinkContainer__66VVk"};